<template>
  <div
    v-if="jumboSwatchUrl"
    class="jumbo-swatch-wrapper"
  >
    <img
      class="swatch-img"
      :src="jumboSwatchUrl"
      :alt="selectedColor?.name || 'selected color'"
    >
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { useTraits } from '@composables/useTraits';
import useUrlTemplate from '@composables/useUrlTemplate';

const { selectedColor } = useTraits();
const { productUrlTemplate } = useUrlTemplate();
const jumboSwatchUrl = computed(() => `${productUrlTemplate}${selectedColor.value?.swatchImage.filePath}?op_sharpen=1&wid=75&hei=75&fit=fit,1&$filtersm$`);
</script>

<style lang="scss" scoped>
.jumbo-swatch-wrapper {
  position: absolute;
  bottom: 0;
  right: 0;
  z-index: 10;
}
.swatch-img {
  margin: rem-calc(0 16 16 0);
  width: rem-calc(75);
  height: rem-calc(75);
  border: rem-calc(1) solid $gray-2-color;
}
</style>

<style lang="scss" brand="mcom" scoped>
.swatch-img {
  border-radius: 50%;
}
</style>
